import request from '@/utils/request';

export const getLoingInfo = data => {
	return request({
		url: '/console/album/v1',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

export const postTrack = data => {
	return request({
		url: '/promotion/statistics/data',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

export const postTrackCourse = data => {
	return request({
		url: '/business/userCourseStatistics/log',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

export const postGetWechatConfig = data => {
	return request({
		url: '/open-api/wechat/service/serviceJsTicketSign',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

// 发送短信验证码
export const postSendPhoneCode = data => {
	return request({
		url: '/open-api/sms/sendAuthCode',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

// 校验短信验证码
export const postValidPhoneCode = data => {
	return request({
		url: '/open-api/sms/authCode',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

export const getPromotionRelation = data => {
	return request({
		url: '/business/promotion/getPromotionRelation',
		method: 'get',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		params: data,
	})
}

// 获取投放模式
export const getPromotionMode = params => {
	return request({
		url: '/business/promotion/na/getPromotionMode',
		method: 'get',
		type: 'json',
		params,
	});
};

// 根据域名获取微信类型
export const getWeChatTypeByDomain = (data) => {
  return request(
    {
      url: '/business/domainRedirect/na/getWeChatTypeByDomain',
      method: 'get',
      type: 'json', // json、 form
      params: data
    }
  )
}

// 根据域名获取微信类型
export const getWeChatTypeByDomainNew = (data) => {
  return request(
    {
      url: '/business/domain-config/na/get-wechat-account',
      method: 'get',
      type: 'json', // json、 form
      params: data
    }
  )
}
